// removed by extract-text-webpack-plugin
module.exports = {"RoundCheckBox":"RoundCheckbox__RoundCheckBox__2_Sbp","PriceLabel":"RoundCheckbox__PriceLabel__oeT_Y","MainLabel":"RoundCheckbox__MainLabel__1Eo32","ActiveLabel":"RoundCheckbox__ActiveLabel__3wj3S","RoundRadioContainer":"RoundCheckbox__RoundRadioContainer__3x1CB","RoundRadio":"RoundCheckbox__RoundRadio__391Hz","RadioSelected":"RoundCheckbox__RadioSelected__1tI5E","Label":"RoundCheckbox__Label__U5eoi","Icon":"RoundCheckbox__Icon__2gPKT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Checkbox/RoundCheckbox/RoundCheckbox.css
// module id = 200
// module chunks = 0